// i18n
import './locales/i18n';

// scroll bar
import 'simplebar/src/simplebar.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import axios from 'axios';
import { useSelector } from 'react-redux';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// locales
import ThemeLocalization from './locales';
// components
import SnackbarProvider from './components/snackbar';
import { SettingsProvider } from './components/settings';
import { MotionLazyContainer } from './components/animate';
import ScrollToTop from './components/scroll-to-top';

// Check our docs
// https://docs.minimals.cc/authentication/js-version

import { AuthProvider } from './auth/JwtContext';

// ----------------------------------------------------------------------

export default function App() {
    const loggedInUserDetails = useSelector(state => state.userdetails.userValue);
    const assetAccessToken = loggedInUserDetails?.token;


    /* Below code sets Authentication header and Content-Type header when user refresh/ reload the browser window. */
    axios.defaults.headers.common.Authorization = `Bearer ${assetAccessToken}`;
  return (
    <AuthProvider>
      <HelmetProvider>
        <SettingsProvider> 
          <BrowserRouter>
            <ScrollToTop />
            <MotionLazyContainer>
              <ThemeProvider>
             {/*   <ThemeSettings> */}
                  <ThemeLocalization>
                    <SnackbarProvider>
                      <Router />
                    </SnackbarProvider>
                  </ThemeLocalization>
              {/*  </ThemeSettings> */}
              </ThemeProvider>
            </MotionLazyContainer>
          </BrowserRouter>
        </SettingsProvider> 
      </HelmetProvider>
    </AuthProvider>
  );
}
